import { useEffect, useState } from "react";

export default function ReadingProgress() {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const onScroll = () => {
            const h = document.documentElement;
            const scrollTop = h.scrollTop || document.body.scrollTop;
            const scrollHeight = h.scrollHeight - h.clientHeight;
            const p = scrollHeight > 0 ? (scrollTop / scrollHeight) * 100 : 0;
            setProgress(p);
        };
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <div
            className="fixed top-0 left-0 right-0 h-[2px] z-[60] bg-transparent pointer-events-none"
            data-testid="reading-progress"
        >
            <div
                className="h-full bg-gold"
                style={{ width: `${progress}%`, transition: progress === 0 ? "none" : "width 100ms linear" }}
            />
        </div>
    );
}
